import { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { BackLink } from 'src/components/common'
import { useNotification } from 'src/contexts/notification.context'
import { useResource } from 'src/hooks/useResource'
import {
  getResourceRequest,
  getResourceQuestionsRequest,
  createResourceQuestionsRequest,
} from 'src/services/api.service'
import QuestionForm from './form'

export const TeacherNewPracticeQuestion = () => {
  const { id } = useParams()
  const history = useHistory()
  const { resourceType } = useResource()
  const { showNotificationHelper } = useNotification()
  const [error, setError] = useState('')

  const [practice, setPractice] = useState(null)
  const [questions, setQuestions] = useState([])

  useEffect(() => {
    const fetchAsync = async () => {
      let result = await getResourceRequest(resourceType, id)
      const total = result.data?.item?.total
      setPractice(result.data?.item)

      result = await getResourceQuestionsRequest(resourceType, id)
      setQuestions(result.data?.items)
      const qs = result.data?.items || []

      if (qs.length >= total) {
        history.push(`/lessons/${resourceType}/${id}/questions`)
      }
    }
    fetchAsync()
  }, [id])

  const onSubmit = async (values, { /* resetForm, */ setValues }) => {
    try {
      let result = await createResourceQuestionsRequest(resourceType, id, {
        ...values,
        sort_order: questions.length,
      })
      result = await getResourceQuestionsRequest(resourceType, id)
      setQuestions(result.data?.items)

      showNotificationHelper({
        title: 'Success',
        body: 'Question created',
      })

      if (result.data?.items.length >= practice.total) {
        history.push(`/lessons/${resourceType}/${id}/questions`)
      } else {
        console.log('setValues', setValues)
        // resetForm();
        setValues({ ...values, answer_true: '', answer_false: '' })
      }
    } catch (err) {
      console.log(err.response.data?.error[0])
      setError(err.response.data?.error[0])
    }
  }

  return (
    <>
      <div className="sectionHb-top">
        <BackLink to={`/lessons/${resourceType}/${id}/questions`} />
        <h2 className="sectionHb-title">
          {practice?.title},{' '}
          <span className="blue__text">Question #{questions.length + 1}</span>
        </h2>
      </div>

      <div className="sectionHb-block">
        <div className="sectionHb-block__wrap">
          <QuestionForm practice={practice} onSubmit={onSubmit} error={error} />
        </div>
      </div>
    </>
  )
}
